module.exports = __webpack_public_path__ + "static/media/wecare-main-logo.c097918d.svg";